import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography,Link } from "@material-ui/core";
import { Link as RouterLink} from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import Skeleton from "@material-ui/lab/Skeleton";
import { routePaths } from "../../../../config/route-paths";
import { store } from "../../../../../helpers";
import {useTranslation} from 'react-i18next';
const useStyle = makeStyles((theme) => ({
  lastPaidBillcolor: {
    backgroundColor: theme.palette.eInformation?.dark,
    padding: "1vh 1vw",
    color: theme.palette.eWhite?.base,
    marginTop: "3vh",
    fontSize:"0.75rem"
  },
  viewBillStyle:{
    textDecoration: "underline",
    color: theme.palette.eWhite?.base,
    "&:hover": {
      color: theme.palette.eWhite?.base,
    },
  },
  whiteColor: {
    color: theme.palette.eWhite?.base,
    "&:hover": {
      color: theme.palette.eWhite?.base,
    },
  },
  paddingInLine: {
    paddingBottom: "1vh",
    background:theme.palette.eSecondary.base,
    height:"13vh"
  },
  lastPaidMargin:{
    lineHeight:"19px",
    marginTop:"0.65rem"

  }
}));
export default function E_Bills() {
  let classes = useStyle();
  let meterDetails = useSelector((store) => store?.meterDetails);
  let dateFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.SHORT_DATE_FORMAT
  );
  const {t:labels, ready: labelReady} = useTranslation("label-E_POSTPAID_ACCOUNTSUMMARY");
  const primaryIdentifier = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
  const accountId = store.getState().meterDetails[primaryIdentifier];
  let payId=useSelector(
    (store)=>store?.meterDetails?.lastPaymentId
  )
  const currencySymbol=useSelector(
    (state)=>state?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  )

  
  return (
    <Grid container >
      <Grid item xs={12}>
        <Grid
          container
          direction="row"
          justify="space-between"
          className={classes.lastPaidBillcolor}
        >
          <Grid item>{labels("E_LAST_PAID_BILLS")}</Grid>
          <Grid item>
          {
            labelReady ?
            <RouterLink
              to={routePaths.BILLING}
              className={classes.viewBillStyle}
            >
              {labels("E_VIEW_ALL_BILLS")}
            </RouterLink>
            : <Skeleton />
          }
          </Grid>
        </Grid>
      </Grid>
      {dateFormat ? (
        <Grid item xs={12} className={`${classes.whiteColor} ${classes.paddingInLine}`}>
        {
          labelReady ?
          <Typography variant="subtitle2" align="center" className={classes.lastPaidMargin} >
            {meterDetails?.lastPaymentAmount && meterDetails?.lastPaymentDate ? (
              <>
                {labels("E_LAST_PAID")}
                {" "}
                {meterDetails?.curSymbol +
                  meterDetails?.lastPaymentAmount +
                  " " +
                  labels("E_ON") +
                  " " +
                  moment(meterDetails?.lastPaymentDate).format(dateFormat)}{" "}
                &nbsp; <br/>
                <RouterLink
                  className={classes.viewBillStyle}
                  variant="caption"
                  to={{
                      pathname: `${routePaths.PAYMENT_RECEIPT}/${accountId}/${
                          payId}`,
                      data: {
                          accountID: accountId,
                          currency: currencySymbol,
                          payId:payId
                      },
                  }}>
                     {labels("E_VIEW_BILL_LINK")}
                  </RouterLink>
              </>
            ) : (
              <Typography className={classes.whiteColor}>{labels("E_POSTPAID_ACCOUNT_SUMMARY_NO_PAYMENTS_FOUND")}</Typography>
            )}{" "}
          </Typography>
          : <Skeleton />
        }
        </Grid>
      ) : (
        <Skeleton />
      )}
    </Grid>
  );
}
